import * as React from "react";
const ThjodskraIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="86 40 111 204" {...props}>
        <defs>
            <clipPath id="a">
                <path d="M0 0h283.465v283.465H0Z" />
            </clipPath>
        </defs>
        <g fill="var(--thjodskra-icon-color, #18154c)" clipPath="url(#a)">
            <path d="m135.21 40.737-48.12 23.42c-.563.272-.92.842-.92 1.466v64.682c0 .9.73 1.629 1.631 1.629h48.12a1.63 1.63 0 0 0 1.628-1.63V42.209a1.632 1.632 0 0 0-2.34-1.471M135.247 140.79l-48.08 21.285a1.651 1.651 0 0 0-.982 1.508v77.656c-.002.91.735 1.65 1.648 1.65.228.003.456-.045.666-.137l48.08-21.116c.6-.262.986-.856.986-1.513v-77.807a1.65 1.65 0 0 0-2.318-1.527M145.921 191.62a1.658 1.658 0 0 1-1.659-1.66v-56.368c0-.914.742-1.657 1.66-1.657h48.063c.915 0 1.658.743 1.658 1.657v8.305c0 27.46-22.26 49.722-49.722 49.722M169.952 70.315c15.101 0 27.342 12.24 27.342 27.34s-12.24 27.343-27.342 27.343c-15.1 0-27.34-12.242-27.34-27.342 0-15.101 12.24-27.341 27.34-27.341" />
        </g>
    </svg>
);
export default ThjodskraIcon;
